<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-3 d-flex align-items-center">
                <input v-model="filters.showArchived" id="show_archived" type="checkbox" class="form-check-input m-0 me-1">
                <label class="form-label m-0" for="show_archived">Show Archived</label>
            </div>
            <div class="col-md-3 d-flex align-items-center">
                <input v-model="filters.showEnabledOnly" id="show_enabled_only" type="checkbox" class="form-check-input m-0 me-1">
                <label class="form-label m-0" for="show_enabled_only">Show Enabled Only</label>
            </div>
        </div>
        <table ref="table" class="table table-bordered table-striped table-vcenter dataTable">
            <thead>
                <tr>
                    <th>Code</th>
                    <th>Name</th>
                    <th></th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>
import { Eventbus } from '@/components/eventbus';
import AccountCodeToggle from "./accountCodeToggle.vue";
import { createApp } from 'vue';

export default {
    props: {
        ajaxUrl: String,
        toggleUrl: String,
    },

    data () {
        return {
            filters: {
                showArchived: false,
                showEnabledOnly: true,
            },
        }
    },

    mounted() {
        let table = window.jQuery(this.$refs.table).on('preXhr.dt', (e, settings, data) => {
            data.filters = this.filters;
        }).DataTable({
            processing: true,
            serverSide: true,
            ajax: {
                url: this.ajaxUrl,
            },
            order: [[0, 'asc']],
            columns: [
                {
                    data: 'code',
                },
                {
                    data: 'name',
                    render: (data, type, row) => `${data} ${row.archived ? ' (archived)' : ''}`,
                },
                {
                    name: 'actions',
                    render: (data, type, row) => `<settings-account-code-toggle toggle-url="${this.toggleUrl.replace('replace-me', row.id)}" :enabled="${JSON.stringify(row.enabled)}" />`,
                    searchable: false,
                },
            ],
            drawCallback: () => {
                let n = 0;
                for (const el of this.$el.querySelectorAll('settings-account-code-toggle')) {
                    const tag = el.localName;
                    const app = createApp({
                        template: el.outerHTML,
                        name: `${tag} ${++n}`,
                    });
                    app.component(tag, AccountCodeToggle);
                    app.mount(el);
                }
            },
        });

        Eventbus.on('account-codes-table-refresh', () => {
            table.ajax.reload(null, false);
        });

        // watch api to use table without saving it to data
        this.$watch(
            'filters',
            () => table.ajax.reload(null, false),
            {
                deep: true
            }
        );
    }
}
</script>
